import React from 'react';
import styles from './Chat.module.css';
 
import TopBar from '../../components/TopBar/TopBar';
 
import ChatComp from '../../components/Chat/ChatComp';


const Chat = (props) => {  
    return (
        <div className={styles.container}>
            <TopBar head="Replies" />
             
            <ChatComp />
        </div>
    )
}

export default Chat;